import { createSelector } from "reselect";
import get from "lodash/get";
import { forms } from "utils/constants";
import { userEmailSelector } from "../authInfo";
import { isEmpty } from "lodash";

/**
 * Extracting User Login from values
 * @param {object} state
 */
const loginFormDomain = state =>
  get(state, `form.${forms.USER_LOGIN_FORM}.values`, {});
const userOrdersDomain = state => get(state, "api.userOrders.data", []);

/**
 * ************ Login Form Selectors ************
 */
export const loginEmailSelector = createSelector(
  loginFormDomain,
  userOrdersDomain,
  (loginForm, orders) => {
    const email = get(loginForm, "email");
    const userEmail = orders[0]?.order_user_detail?.email;
    let emailValue = typeof email === "object" ? email.value : email || "";
    return emailValue.includes("@")
      ? emailValue
      : isEmpty(userEmail)
      ? emailValue
      : userEmail;
  }
);

export const loginFormSelector = createSelector(
  loginFormDomain,
  loginForm => loginForm
);

export const loginFormMessageDataSelector = createSelector(
  loginEmailSelector,
  userEmailSelector,
  (loginEmail, userEmail) => ({
    userEmail,
    loginEmail,
    email: userEmail || loginEmail
  })
);

/**
 * ************ Make Selectors ************
 */
export const makeSelectLoginEmail = () => loginEmailSelector;

export const makeSelectLoginFormMessageData = () =>
  loginFormMessageDataSelector;

export const makeSelectLoginForm = () => loginFormSelector;
